import {Scene} from 'scene'
import {Animation} from 'animation';
import {Commands}from 'commands';
import {SmartObject} from 'commands';

import {COLOR} from 'game';

const Sprite = (texture_name) => {
    return new PIXI.Sprite(PIXI.utils.TextureCache[texture_name])
};

const createAnimation = (name_pattern, frames_count, animation_speed = 0.2, loop = false) => {
    let anim = Animation.byFrameName(name_pattern, frames_count);
    anim.animationSpeed = animation_speed;
    anim.loop = loop;

    return anim;
};

export default class GameScene extends Scene {
    constructor(controller) {
        super();

        this.interactive = true;

        this.controller = controller;

        this.fon = new PIXI.Sprite(PIXI.utils.TextureCache['res/screen.png']);
        this.addChild(this.fon);

        this.availableTurn = [];
        for (let i = 0; i < 24; ++i) {
            let markPair = [];
            for (let j = 0; j < 2; ++j) {
                let markTurn = Sprite('available_turn_' + j + '.png' );
                if (i < 12) {
                    // markTurn.x = 1565 - 103 * i - ((i > 5) ? 110 : 0);
                    // markTurn.y = 3;

                    markTurn.x = 1565 - 103 * i - ((i > 5) ? 110 : 0);
                    markTurn.y = 1028;
                }
                else {
                    markTurn.x = 329 + 103 * (i - 12) + ((i > 17) ? 110 : 0);
                    markTurn.y = 3;
                }

                markTurn.visible = false;

                markPair.push(markTurn);
                this.addChild(markTurn);
            }

            this.availableTurn.push(markPair);
        }


        this.blackChips = [];
        this.whiteChips = [];
        this.blackHomeChips = [];
        this.whiteHomeChips = [];

        this.containerChips = new PIXI.Container();
        this.addChild(this.containerChips);

        for (let i = 0; i < 15; ++i) {

            let blackChip = new PIXI.Sprite(PIXI.utils.TextureCache['chip_black.png']);
            blackChip.position = this.getChipPosition(11, 15, i);
            this.containerChips.addChild(blackChip);//this.addChild(blackChip);
            this.blackChips.push(blackChip);

            let whiteChip = new PIXI.Sprite(PIXI.utils.TextureCache['chip_white.png']);
            whiteChip.position = this.getChipPosition(23, 15, i);
            this.containerChips.addChild(whiteChip);//this.addChild(whiteChip);
            this.whiteChips.push(whiteChip);

            let blackHomeChip = new PIXI.Sprite(PIXI.utils.TextureCache['chip_home_black_lu.png']);
            blackHomeChip.position.set(91, 488 - i * 16);
            this.addChild(blackHomeChip);
            this.blackHomeChips.push(blackHomeChip);
            blackHomeChip.visible = false;

            let whiteHomeChip = new PIXI.Sprite(PIXI.utils.TextureCache['chip_home_white_ru.png']);
            whiteHomeChip.position.set(1746, 831 - i * 16);
            this.addChild(whiteHomeChip);
            this.whiteHomeChips.push(whiteHomeChip);
            whiteHomeChip.visible = false;
        }

        this.blackDiceFirst = [];
        this.blackDiceSecond = [];
        for (let i = 1; i < 7; ++i) {
            for (let j = 0; j < 2; ++j) {
                let dice = createAnimation('dice_black_' + i + '_%03d.png', 15, 0.3);
                if (j === 0) {
                    //dice.position.set(428, 412);
                    this.blackDiceFirst.push(dice);
                }
                else {
                    dice.scale.y = -1.0;
                    dice.y = 200;//dice.position.set(554, 474);
                    this.blackDiceSecond.push(dice);
                }

                //dice.visible = false;
                //this.addChild(dice);
            }
        }

        this.whiteDiceFirst = [];
        this.whiteDiceSecond = [];
        for (let i = 1; i < 7; ++i) {
            for (let j = 0; j < 2; ++j) {
                let dice = createAnimation('dice_white_' + i + '_%03d.png', 15, 0.3);
                if (j === 0) {
                    //dice.position.set(1280, 412);
                    this.whiteDiceFirst.push(dice);
                }
                else {
                    dice.scale.y = -1.0;
                    dice.y = 200;//dice.position.set(1386, 474 + 200);
                    this.whiteDiceSecond.push(dice);
                }

                //dice.visible = false;
                //this.addChild(dice);
            }
        }

        this.blackFirstDiceCont = SmartObject.mixin(new PIXI.Container());
        this.blackFirstDiceCont.position.set(428, 412);
        this.addChild(this.blackFirstDiceCont);
        this.blackSecondDiceCont = SmartObject.mixin(new PIXI.Container());
        this.blackSecondDiceCont.position.set(554, 474);
        this.addChild(this.blackSecondDiceCont);

        this.whiteFirstDiceCont = SmartObject.mixin(new PIXI.Container());
        this.whiteFirstDiceCont.position.set(1280, 412);
        this.addChild(this.whiteFirstDiceCont);
        this.whiteSecondDiceCont = SmartObject.mixin(new PIXI.Container());
        this.whiteSecondDiceCont.position.set(1386, 474);
        this.addChild(this.whiteSecondDiceCont);

        this.availableCell = [];
        for (let i = 0; i < 24; ++i) {
            let cell = createAnimation('lighting_cell_%03d.png', 21, 0.2, true);

            if (i < 12) {
                cell.scale.y = -1.0;
                cell.x = 1508 - i * 101 - ((i > 5) ? 115 : 0);
                cell.y = 646 + 400//38;
            }
            else {
                // cell.scale.y = -1.0;
                cell.x = 283 + (i - 12) * 101 + ((i > 17) ? 115 : 0);
                cell.y = 38//646 + 400;
            }

            this.addChild(cell);
            this.availableCell.push(cell);
            cell.visible = false;
        }

        let baseWhiteCell = createAnimation('lighting_cell_%03d.png', 21, 0.2, true);
        baseWhiteCell.position.set(1717, 886);
        baseWhiteCell.scale.y = -1.0;
        baseWhiteCell.visible = false;
        this.addChild(baseWhiteCell);
        this.availableCell.push(baseWhiteCell);
        let baseBackCell = createAnimation('lighting_cell_%03d.png', 21, 0.2, true);
        baseBackCell.position.set(59, 202);
        this.addChild(baseBackCell);
        baseBackCell.visible = false;
        this.availableCell.push(baseBackCell);

        this.avatarRed = createAnimation('red_%03d.png', 15, 0.2);
        this.avatarRed.position.set(1721, 873);
        this.addChild(this.avatarRed);

        this.avatarBlue = createAnimation('blue_%03d.png', 15, 0.2);
        this.avatarBlue.position.set(57, 29);
        this.addChild(this.avatarBlue);

        this.advantageArrow = new PIXI.Container();
        let shadowArrow = Sprite('arrow_shadow.png');
        this.advantageArrow.addChild(shadowArrow);
        let arrow = Sprite('arrow.png');
        arrow.position.set(0, -5);
        this.advantageArrow.addChild(arrow);
        this.advantageArrow.position.set(0, 530);
        this.addChild(this.advantageArrow);

        this.dialogs = [];
        const dialogPos = [
            {x: 323, y: 573},
            {x: 1374, y: 573},
        ];
        let leftDialogs = [];
        for (let j = 0; j < 3; ++j) {
            let dialog = Sprite('left_dialog_%d.png'.$(j));
            dialog.position = dialogPos[1];
            this.addChild(dialog)
            leftDialogs.push(dialog);
            dialog.visible = false;
        }
        let rightDialogs = [];
        for (let k = 0; k < 3; ++k) {
            let dialog = Sprite('right_dialog_%d.png'.$(k));
            dialog.position = dialogPos[0];
            this.addChild(dialog)
            rightDialogs.push(dialog);
            dialog.visible = false;
        }

        this.dialogs = [rightDialogs, leftDialogs];

        const baseArea = [
            {x: 1742, y: 222, w: 118, h: 638},
            {x: 74, y: 222, w: 118, h: 638},
        ];
        this.pointInteractiveAreas = [];
        for (let i = 0; i < 26; ++i) {

            let x = 0;
            let y = 0;

            if (i < 12) {
                x = 1532 - 100 * i - ((i > 5) ? 120 : 0);
                y = 550;//63
            }
            else {
                x = 308 + 100 * (i - 12) + ((i > 17) ? 120 : 0);
                y = 63;//550
            }

            let area = new PIXI.Graphics();
            area.alpha = 0.3;
            if (i > 23) {
                let preset = baseArea[i-24];
                // area.beginFill(0x0033CC);
                // area.lineStyle(4, 0xFF0000, 1);
                // area.drawRect(preset.x, preset.y, preset.w, preset.h);
                // area.endFill();
                area.hitArea = new PIXI.Rectangle(preset.x, preset.y, preset.w, preset.h);
            }
            else {
                // area.beginFill(0x0033CC);
                // area.lineStyle(4, 0xFF0000, 1);
                // area.drawRect(x, y, 100, 470);
                // area.endFill();
                area.hitArea = new PIXI.Rectangle(x, y, 100, 470);
            }
            area.pointerdown = () => {
                //console.log('click ', i)

                this.controller.choiceCell(i);

                //this.interactive = false;
            };

            area.interactive = false;
            this.addChild(area);
            this.pointInteractiveAreas.push(area);

        }

        this.undoButton = createAnimation('undo_%03d.png', 12, 0.2, true);
        this.undoButton.position.set(865, 409);
        this.addChild(this.undoButton);

        this.hideUndoButton();

        // this.whiteChipsOnCell = [
        //     [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],
        //     [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
        // ]
        this.whiteChipsOnCell = [
            [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],   []
        ];

        // this.blackChipsOnCell = [
        //     [],[],[],[],[],[],[],[],[],[],[],
        //     [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        //     [],[],[],[],[],[],[],[],[],[],[],[]
        // ];
        this.blackChipsOnCell = [
            [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],   []
        ];
    };

    update(dt) {

        this.blackFirstDiceCont.updateCommands(dt);
        this.blackSecondDiceCont.updateCommands(dt);
        this.whiteFirstDiceCont.updateCommands(dt);
        this.whiteSecondDiceCont.updateCommands(dt);
    };

    getChipPosition(pointId, countChipsInPoint, chipOrderId) {

        let upY = 85;
        let downY = 899;
        let rightFirstX = 1534;
        let leftFirstX = 307;
        let xDelta = 101;

        let yDelta = 96 - (countChipsInPoint - 1) * 5;

        let x = 0;
        let y= 0;

        if (pointId < 12) {
            x = rightFirstX - pointId * xDelta - ((pointId > 5) ? 115 : 0);
            y = downY - chipOrderId * yDelta;//upY + chipOrderId * yDelta;
        }
        else {
            x = leftFirstX + (pointId - 12) * xDelta + ((pointId > 17) ? 115 : 0);
            y = upY + chipOrderId * yDelta;//downY - chipOrderId * yDelta;
        }

        return {x: x, y: y};
    };

    setChipsOnBoard(board, base, out) {

        this.whiteChipsOnCell = [
            [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],   [],[]
        ];

        this.blackChipsOnCell = [
            [],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],   [],[]
        ];

        let whiteBoard = board[COLOR.WHITE].slice();
        let currentChipsId = 0;
        for (let cell = 0; cell < whiteBoard.length; ++cell) {
            if (whiteBoard[cell] > 0) {
                for (let ch = 0; ch < whiteBoard[cell]; ++ch) {
                    this.whiteChips[currentChipsId].position = this.getChipPosition(cell, whiteBoard[cell], ch);
                    this.whiteChipsOnCell[cell].push(currentChipsId);
                    this.whiteChips[currentChipsId].visible = true;

                    currentChipsId++
                }
            }
        }

        let blackBoard = board[COLOR.BLACK].slice();
        currentChipsId = 0;
        for (let cell = 0; cell < blackBoard.length; ++cell) {
            if (blackBoard[cell] > 0) {
                for (let ch = 0; ch < blackBoard[cell]; ++ch) {
                    this.blackChips[currentChipsId].position = this.getChipPosition(cell, blackBoard[cell], ch);
                    this.blackChipsOnCell[cell].push(currentChipsId);
                    this.blackChips[currentChipsId].visible = true;

                    currentChipsId++
                }
            }
        }

    }

    startTurn(color) {
        if (color === COLOR.WHITE) {
            this.avatarRed.alpha = 1.0;
            this.avatarRed.gotoAndPlay(0);
            this.avatarBlue.alpha = 0.5;
            this.avatarBlue.gotoAndStop(0);
        }
        else {
            this.avatarRed.alpha = 0.5;
            this.avatarRed.gotoAndStop(0);
            this.avatarBlue.alpha = 1.0;
            this.avatarBlue.gotoAndPlay(0);
        }

    }

    endTurn(color) {
        if (color === COLOR.WHITE) {
            this.avatarRed.alpha = 0.5;
            this.avatarRed.gotoAndStop(0);

            this.whiteFirstDiceCont.removeChildren();
            //this.whiteFirstDiceCont.clear();
            this.whiteSecondDiceCont.removeChildren();
            //this.whiteSecondDiceCont.clear();
        }
        else {
            this.avatarBlue.alpha = 0.5;
            this.avatarBlue.gotoAndStop(0);

            this.blackFirstDiceCont.removeChildren();
            //this.blackFirstDiceCont.clear();
            this.blackSecondDiceCont.removeChildren();
            //this.blackSecondDiceCont.clear();
        }

        this.whiteFirstDiceCont.removeChildren();
        //this.whiteFirstDiceCont.clear();
        this.whiteSecondDiceCont.removeChildren();
        //this.whiteSecondDiceCont.clear();
        this.blackFirstDiceCont.removeChildren();
        //this.blackFirstDiceCont.clear();
        this.blackSecondDiceCont.removeChildren();
        //this.blackSecondDiceCont.clear();
    }

    sayCantTurn(color, done) {
        this.dialogs[color][0].visible = true;

        setTimeout(() => {
            this.dialogs[color][0].visible = false;
            done();
        }, 1500 )
    }

    sayWin(color, isMars, done) {

        let dialogWin = (isMars) ? 1 : 2;

        this.dialogs[color][dialogWin].visible = true;

        // setTimeout(() => {
        //     this.dialogs[color][dialogWin].visible = false;
        //     done();
        // }, 1500 )
    }

    showUndoButton() {
        // this.undoButton.pointerdown = () => {
        //
        //     console.log('CLICK UNDO!!!');
        //
        //     this.controller.undoLastTurn();
        // };
        //
        // this.undoButton.visible = true;
        // this.undoButton.gotoAndPlay(0);
        // this.undoButton.interactive = true;
    }

    hideUndoButton() {
        this.undoButton.visible = false;
        this.undoButton.gotoAndStop(0);
        this.undoButton.interactive = false;
    }

    rollFirstDice(dice, prev,  done) {
        const startPos = [
            {x: 1280, y:412},
            {x: 1386, y: 474},
            {x: 428, y: 412},
            {x: 554, y: 474}
        ];

        this.blackFirstDiceCont.removeChildren();
        // this.blackFirstDiceCont.clear();
        this.blackSecondDiceCont.removeChildren();
        this.blackSecondDiceCont.clear();
        this.whiteFirstDiceCont.removeChildren();
        // this.whiteFirstDiceCont.clear();
        this.whiteSecondDiceCont.removeChildren();
        this.whiteSecondDiceCont.clear();

        let prevWhite = this.whiteDiceFirst[prev[0] - 1];
        let prevBlack = this.blackDiceFirst[prev[1] - 1];
        let whiteDice = this.whiteDiceFirst[dice[0] - 1];
        let blackDice = this.blackDiceFirst[dice[1] - 1];

        this.whiteFirstDiceCont.position = startPos[0];
        this.whiteFirstDiceCont.addChild(prevWhite);
        prevWhite.visible = true;
        this.whiteFirstDiceCont.addChild(whiteDice);
        whiteDice.visible = false;
        this.blackFirstDiceCont.position = startPos[2];
        this.blackFirstDiceCont.addChild(prevBlack);
        prevBlack.visible = true;
        this.blackFirstDiceCont.addChild(blackDice);
        blackDice.visible = false;

        this.whiteFirstDiceCont.addCommand(0, Commands.MoveTo, startPos[1], 800);
        this.whiteFirstDiceCont.addCommand(1, Commands.Animate, prevWhite, 0, 8);
        this.whiteFirstDiceCont.addCommand(1, Commands.Call, () => {
            prevWhite.visible = false;
            whiteDice.visible = true;
            whiteDice.gotoAndStop(8);
        });
        this.whiteFirstDiceCont.addCommand(1, Commands.Animate, whiteDice, 8, 14);

        this.blackFirstDiceCont.addCommand(0, Commands.MoveTo, startPos[3], 800);
        this.blackFirstDiceCont.addCommand(0, Commands.Wait,  800);
        this.blackFirstDiceCont.addCommand(0, Commands.Call, done);
        this.blackFirstDiceCont.addCommand(1, Commands.Animate, prevBlack, 0, 8);
        this.blackFirstDiceCont.addCommand(1, Commands.Call, () => {
            prevBlack.visible = false;
            blackDice.visible = true;
            blackDice.gotoAndStop(8);
        });
        this.blackFirstDiceCont.addCommand(1, Commands.Animate, blackDice, 8, 14);

    }

    showDice(color, prevDice, dice, done) {

        const startPos = [
            {x: 1280, y:412},
            {x: 1386, y: 474},
            {x: 428, y: 412},
            {x: 554, y: 474}
        ];

        this.blackFirstDiceCont.removeChildren();
        this.blackFirstDiceCont.clear();
        this.blackSecondDiceCont.removeChildren();
        this.blackSecondDiceCont.clear();
        this.whiteFirstDiceCont.removeChildren();
        this.whiteFirstDiceCont.clear();
        this.whiteSecondDiceCont.removeChildren();
        this.whiteSecondDiceCont.clear();

        let prev = prevDice.slice();
        if (prev.length === 0) {
            prev = [6, 6];
        }

        prev.reverse();

        if (color === COLOR.WHITE) {

            let prevFirstDice = this.whiteDiceFirst[prev[0] - 1];
            let prevSecondDice = this.whiteDiceSecond[prev[1] - 1];
            let nextFirstDice = this.whiteDiceFirst[dice[0] - 1];
            let nextSecondDice = this.whiteDiceSecond[dice[1] - 1]

            prevFirstDice.visible = true;
            nextFirstDice.visible = false;
            prevFirstDice.gotoAndStop(0);
            prevSecondDice.visible = true;
            nextSecondDice.visible = false;
            prevSecondDice.gotoAndStop(0);

            this.whiteFirstDiceCont.position = startPos[0];
            this.whiteFirstDiceCont.addChild(prevFirstDice);
            this.whiteFirstDiceCont.addChild(nextFirstDice);
            this.whiteSecondDiceCont.position = startPos[1];
            this.whiteSecondDiceCont.addChild(prevSecondDice);
            this.whiteSecondDiceCont.addChild(nextSecondDice);

            this.whiteFirstDiceCont.addCommand(0, Commands.MoveTo, startPos[1], 800);
            this.whiteFirstDiceCont.addCommand(1, Commands.Animate, prevFirstDice, 0, 8);
            this.whiteFirstDiceCont.addCommand(1, Commands.Call, () => {
                prevFirstDice.visible = false;
                nextFirstDice.visible = true;
                nextFirstDice.gotoAndStop(8);
            });
            this.whiteFirstDiceCont.addCommand(1, Commands.Animate, nextFirstDice, 8, 14);

            this.whiteSecondDiceCont.addCommand(0, Commands.MoveTo, startPos[0], 800);
            this.whiteSecondDiceCont.addCommand(0, Commands.Call, done);
            this.whiteSecondDiceCont.addCommand(1, Commands.Animate, prevSecondDice, 0, 8);
            this.whiteSecondDiceCont.addCommand(1, Commands.Call, () => {
                prevSecondDice.visible = false;
                nextSecondDice.visible = true;
                nextSecondDice.gotoAndStop(8);
            });
            this.whiteSecondDiceCont.addCommand(1, Commands.Animate, nextSecondDice, 8, 14);

        }
        else {
            let prevFirstDice = this.blackDiceFirst[prev[0] - 1];
            let prevSecondDice = this.blackDiceSecond[prev[1] - 1];
            let nextFirstDice = this.blackDiceFirst[dice[0] - 1];
            let nextSecondDice = this.blackDiceSecond[dice[1] - 1]

            prevFirstDice.visible = true;
            nextFirstDice.visible = false;
            prevFirstDice.gotoAndStop(0);
            prevSecondDice.visible = true;
            nextSecondDice.visible = false;
            prevSecondDice.gotoAndStop(0);

            this.blackFirstDiceCont.position = startPos[2];
            this.blackFirstDiceCont.addChild(prevFirstDice);
            this.blackFirstDiceCont.addChild(nextFirstDice);
            this.blackSecondDiceCont.position = startPos[3];
            this.blackSecondDiceCont.addChild(prevSecondDice);
            this.blackSecondDiceCont.addChild(nextSecondDice);

            this.blackFirstDiceCont.addCommand(0, Commands.MoveTo, startPos[3], 800);
            this.blackFirstDiceCont.addCommand(1, Commands.Animate, prevFirstDice, 0, 8);
            this.blackFirstDiceCont.addCommand(1, Commands.Call, () => {
                prevFirstDice.visible = false;
                nextFirstDice.visible = true;
                nextFirstDice.gotoAndStop(8);
            });
            this.blackFirstDiceCont.addCommand(1, Commands.Animate, nextFirstDice, 8, 14);

            this.blackSecondDiceCont.addCommand(0, Commands.MoveTo, startPos[2], 800);
            this.blackSecondDiceCont.addCommand(0, Commands.Call, done);
            this.blackSecondDiceCont.addCommand(1, Commands.Animate, prevSecondDice, 0, 8);
            this.blackSecondDiceCont.addCommand(1, Commands.Call, () => {
                prevSecondDice.visible = false;
                nextSecondDice.visible = true;
                nextSecondDice.gotoAndStop(8);
            });
            this.blackSecondDiceCont.addCommand(1, Commands.Animate, nextSecondDice, 8, 14);
        }

        //done();

    }

    showAvailableStartCell(turns) {
        //console.log('TURNS: ', turns);

        this.pointInteractiveAreas.forEach(a => a.interactive = false);
        this.availableCell.forEach(cell => {
            cell.stop();
            cell.visible = false;
        });
        this.availableTurn.forEach(t => {
            t[0].visible = false;
            t[1].visible = false;
        });

        for (let i = 0; i < turns.length; ++i) {

            let id = turns[i][0];

            this.availableTurn[id][0].visible = true;
            this.pointInteractiveAreas[id].interactive = true;
        }
    }

    showAvailableEndCell(turns, chosenStart) {
        //console.log('TURNS: ', turns);

        this.pointInteractiveAreas.forEach(a => a.interactive = false);

        this.availableTurn[chosenStart][1].visible = true;

        for (let i = 0; i < turns.length; ++i) {

            let id = turns[i][1];

            this.availableCell[id].visible = true;
            this.availableCell[id].gotoAndPlay(0);

            this.pointInteractiveAreas[id].interactive = true;
        }

        this.pointInteractiveAreas[chosenStart].interactive = true;
    }

    doMoveChip(color, start, end, isUndo, done) {

        console.log('MOVE: ', color, start, end)

        this.pointInteractiveAreas.forEach(a => a.interactive = false);
        this.availableCell.forEach(cell => {
            cell.stop();
            cell.visible = false;
        });
        this.availableTurn.forEach(t => {
            t[0].visible = false;
            t[1].visible = false;
        });

        const timeCoef = 1500 / 1350;


        if (color === COLOR.WHITE) {

            let id = this.whiteChipsOnCell[start][this.whiteChipsOnCell[start].length - 1];
            let movedChip = this.whiteChips[id];

            const complete = () => {
                //this.whiteChipsOnCell[start].splice(-1, 1);

                if (end > 23) {
                    movedChip.visible = false;
                    this.whiteHomeChips[this.controller.getBaseCount(COLOR.WHITE)].visible = true;
                }
                // else {
                //     this.whiteChipsOnCell[end].push(id);
                // }

                //console.log(this.whiteChipsOnCell[start], this.whiteChipsOnCell[end])

                if (done) {
                    done();
                }
            };

            //сортировка фишек
            this.containerChips.removeChild(movedChip);
            this.containerChips.addChild(movedChip);
            //

            if (this.whiteChipsOnCell[start].length - 1 > 0) {
                let startChips = this.whiteChipsOnCell[start];
                for (let i = 1; i < startChips.length - 1; ++i) {

                    let newPos = this.getChipPosition(start, startChips.length - 1, i);

                    let condenceTween = new TWEEN.Tween(this.whiteChips[startChips[i]])
                        .to(newPos, 500)
                        .start();
                }
            }

            let position = {};
            if (end > 23) {
                position = {x: 1750, y: 758};
            }
            else {
                let endChips = this.whiteChipsOnCell[end];

                for (let i = 1; i < endChips.length; ++i) {

                    let newPos = this.getChipPosition(end, endChips.length + 1, i);

                    let condenceTween = new TWEEN.Tween(this.whiteChips[endChips[i]])
                        .to(newPos, 500)
                        .start();
                }

                position = this.getChipPosition(end, endChips.length + 1, endChips.length);
            }

            //
            this.whiteChipsOnCell[start].splice(-1, 1);
            if (end < 24) {
                this.whiteChipsOnCell[end].push(id);
            }
            //

            let time = (isUndo) ? 500 : Math.max(Math.abs(movedChip.x - position.x), Math.abs(movedChip.y - position.y)) * timeCoef;
            let moveTween = new TWEEN.Tween(movedChip)
                .to(position, time)
                .onComplete(() => {
                    complete()
                })
                .start();
        }
        else {
            let id = this.blackChipsOnCell[start][this.blackChipsOnCell[start].length - 1];
            let movedChip = this.blackChips[id];

            const complete = () => {
                //this.blackChipsOnCell[start].splice(-1, 1);

                if (end > 23) {
                    movedChip.visible = false;
                    this.blackHomeChips[this.controller.getBaseCount(COLOR.BLACK)].visible = true;
                }
                // else {
                //     this.blackChipsOnCell[end].push(id);
                // }


                done();
            };

            //сортировка фишек
            this.containerChips.removeChild(movedChip);
            this.containerChips.addChild(movedChip);
            //

            let position = {};

            if (this.blackChipsOnCell[start].length - 1 > 0) {
                let startChips = this.blackChipsOnCell[start];
                for (let i = 1; i < startChips.length - 1; ++i) {

                    let newPos = this.getChipPosition(start, startChips.length - 1, i);

                    let condenceTween = new TWEEN.Tween(this.blackChips[startChips[i]])
                        .to(newPos, 500)
                        .start();
                }
            }

            if (end > 23) {
                position = {x: 85, y: 225};
            }
            else {
                let endChips = this.blackChipsOnCell[end];

                for (let i = 1; i < endChips.length; ++i) {

                    let newPos = this.getChipPosition(end, endChips.length + 1, i);

                    let condenceTween = new TWEEN.Tween(this.blackChips[endChips[i]])
                        .to(newPos, 500)
                        .start();
                }

                position = this.getChipPosition(end, endChips.length + 1, endChips.length);
            }

            //
            this.blackChipsOnCell[start].splice(-1, 1);
            if (end < 24) {
                this.blackChipsOnCell[end].push(id);
            }
            //

            let time = (isUndo) ? 500 : Math.max(Math.abs(movedChip.x - position.x), Math.abs(movedChip.y - position.y)) * timeCoef;
            let moveTween = new TWEEN.Tween(movedChip)
                .to(position, time)
                .onComplete(() => {
                    complete()
                })
                .start();
        }

    }

    // startGameLoop() {
    //
    // }
}


// WEBPACK FOOTER //
// ./src/game_scene.es6